import { ConfigValidationError } from "../../../../../../types";
import { ComponentConfigState } from "../../../../types";
import selectValidationRulesErrors from "../../common/ValidationField/selectValidationRulesErrors";
import selectVisibilityRuleErrors from "../../common/VisibilityRulesManager/selectErrors";

export default function errorSelector(
  state: ComponentConfigState
): ConfigValidationError[] {
  const errors: ConfigValidationError[] = [];
  const { draftComponent } = state;
  return errors
    .concat(selectVisibilityRuleErrors(draftComponent))
    .concat(selectValidationRulesErrors(draftComponent));
}
